const BUILDER_ACTIONS = {
  update: 'UPDATE',
  updateStep: 'UPDATE_STEP',
  updateModel: 'UPDATE_MODEL',
  reset: 'RESET',
  validate: 'VALIDATE',
};
export default BUILDER_ACTIONS;
